import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5dfc4a86")

_pushScopeId("data-v-5dfc4a86")
const _hoisted_1 = { class: "insurance-popup" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, " Welke verzekering heeft uw werkgever voor u afgesloten? ", -1)
const _hoisted_3 = {
  key: 0,
  class: "insurance-block"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("h4", null, "WIA-werknemersverzekering", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" U ontvangt een uitkering uit de ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("WIA-werknemersverzekering")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" bij een ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("arbeidsongeschiktheidspercentage")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" tussen de 15% en de 80%. ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Bent u tussen de 15% en 35% arbeidsongeschikt? Dan ontvangt u de uitkering maximaal 7,5 jaar. Bent u tussen de 35% en 80% arbeidsongeschikt en werkt u? Dan ontvangt u de uitkering tot aan uw ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("AOW-leeftijd")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" . ")
const _hoisted_13 = {
  key: 1,
  class: "insurance-block"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("h4", null, "WIA-excedentverzekering", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Met de ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("WIA-werknemersverzekering")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("WIA-excedentverzekering")
const _hoisted_18 = {
  key: 2,
  class: "insurance-block"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("h4", null, "WIA-excedentverzekering Top", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("WIA-excedentverzekering")
const _hoisted_21 = { class: "premium" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" U betaalt aan premie: ")
const _hoisted_23 = { class: "premium-amount" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" per jaar ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("*")
const _hoisted_26 = {
  key: 3,
  class: "excedent-top-warning"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("a", { href: "https://www.nvschade.nl/werknemer/hoe-zit-het-met-mijn-inkomen/" }, " Lees meer over de verzekeringen van NV schade ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NVAbbr = _resolveComponent("NVAbbr")
  const _component_Explain = _resolveComponent("Explain")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Explain, { title: "Mijn Verzekeringen" }, {
      default: _withId(() => [
        _hoisted_2,
        (_ctx.state.insurance.hasWIAEmployee)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("p", null, [
                _hoisted_5,
                _createVNode(_component_NVAbbr, { href: "https://www.nvschade.nl/werknemer/wia-werknemersverzekering/" }, {
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _hoisted_7,
                _createVNode(_component_NVAbbr, null, {
                  default: _withId(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _hoisted_9
              ]),
              _createVNode("p", null, [
                _hoisted_10,
                _createVNode(_component_NVAbbr, null, {
                  default: _withId(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _hoisted_12
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.insurance.hasWIAExcedent)
          ? (_openBlock(), _createBlock("div", _hoisted_13, [
              _hoisted_14,
              _createVNode("p", null, [
                _hoisted_15,
                _createVNode(_component_NVAbbr, { href: "https://www.nvschade.nl/werknemer/wia-werknemersverzekering/" }, {
                  default: _withId(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }),
                _createTextVNode(" is uw loon tot " + _toDisplayString(_ctx.uwvMax) + " verzekerd. Verdient u meer? Met de ", 1 /* TEXT */),
                _createVNode(_component_NVAbbr, { href: "https://www.nvschade.nl/werknemer/wia-excedentverzekering/" }, {
                  default: _withId(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }),
                _createTextVNode(" is uw loon tot maximaal " + _toDisplayString(_ctx.nvExcMax) + " verzekerd. ", 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.insurance.hasWIAExcedentTop)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _hoisted_19,
              _createVNode("p", null, [
                _createTextVNode(" Verdient u meer dan " + _toDisplayString(_ctx.nvExcMax) + "? Met de ", 1 /* TEXT */),
                _createVNode(_component_NVAbbr, { href: "https://www.nvschade.nl/werknemer/wia-excedentverzekering-top/" }, {
                  default: _withId(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }),
                _createTextVNode(" is uw loon tussen de " + _toDisplayString(_ctx.nvExcMax) + " en " + _toDisplayString(_ctx.nvExcTopMax) + " verzekerd. ", 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("p", _hoisted_21, [
          _hoisted_22,
          _createVNode("span", _hoisted_23, _toDisplayString(_ctx.premium), 1),
          _hoisted_24,
          (_ctx.state.insurance.hasWIAExcedentTop)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_25
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("", true)
        ]),
        (_ctx.state.insurance.hasWIAExcedentTop)
          ? (_openBlock(), _createBlock("p", _hoisted_26, " *De premie voor WIA-excedent TOP is niet meegerekend. Neem contact met ons op voor meer informatie. "))
          : _createCommentVNode("", true),
        _hoisted_27
      ]),
      _: 1
    })
  ]))
})